import * as React from 'react'
import styled, { css } from 'styled-components'
import { position, PositionProps } from 'styled-system'

import { COMMON, theme, CommonProps } from 'global'
import { IHand } from 'models'
import { Box } from 'components'
import { AnimalIcon } from 'components/AnimalIcon/AnimalIcon'

const ANIMAL_ICON_POSITIONS = {
  bear: {
    top: '-3%',
    left: '5%',
    scale: 2.7,
  },
  bull: {
    top: '7%',
    left: '-4%',
    scale: 3,
  },
  bunny: {
    top: '20%',
    left: '-6%',
    scale: 2.5,
  },
  kitten: {
    top: '19%',
    left: '13%',
    scale: 2,
  },
  cougar: {
    top: '0',
    left: '-20%',
    scale: 3,
  },
  falcon: {
    top: '7%',
    left: '26%',
    scale: 2.8,
  },
  stallion: {
    top: '15%',
    left: '-5%',
    scale: 2.5,
  },
  hummingbird: {
    top: '12%',
    left: '12%',
    scale: 2.7,
  },
  crab: {
    top: '6%',
    scale: 1.8,
  },
  frog: {
    top: '3%',
    scale: 2.3,
  },
  peacock: {
    scale: 2,
  },
  turtle: {
    top: '21%',
    left: '34%',
    scale: 2.7,
  },
  fox: {
    top: '43%',
    left: '40%',
    scale: 2.8,
  },
  spider: {
    top: '25%',
    scale: 2,
  },
  scorpion: {
    top: '-1%',
    left: '23%',
    scale: 1.8,
  },
  dove: {
    top: '7%',
    left: '21%',
    scale: 2,
  },
  swan: {
    top: '9%',
    left: '44%',
    scale: 2.6,
  },
  butterfly: {
    top: '10%',
    scale: 2.3,
  },
  dolphin: {
    top: '30%',
    left: '4%',
    scale: 3.1,
  },
  shark: {
    left: '67%',
    scale: 3.7,
  },
  bat: {
    top: '14%',
    scale: 3,
  },
  snake: {
    top: '29%',
    left: '-4%',
    scale: 2.8,
  },
  dragon: {
    top: '21%',
    left: '46%',
    scale: 2.5,
  },
  cub: {
    top: '34%',
    left: '26%',
    scale: 2,
  },
  otter: {
    top: '21%',
    left: '70%',
    scale: 3,
  },
}

export const ANIMAL_ICON_BTN_SELECTED_STYLES = `
  border: 5px solid #fff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  box-sizing: border-box;

  @media screen and (min-width: ${theme.maxWidths.large}) {
    width: 70px;
    height: 70px;
  }
`

const ButtonOuter = styled(Box)`
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ButtonStyled = styled.button.attrs({ className: 'animalicon-btn' })<
  Pick<AnimalIconButtonProps, 'selected'> & CommonProps
>`
  ${COMMON}
  ${({ selected }) => css`
    background-color: #4a14b4;
    border-radius: 50%;
    -webkit-appearance: none;
    outline: none;
    overflow: hidden;
    position: relative;

    ${selected &&
      css`
        ${ANIMAL_ICON_BTN_SELECTED_STYLES}
      `}
  `}
`

const AnimalPickerIcon = styled(AnimalIcon)<PositionProps & { scale: number }>`
  ${position}
  transform: ${props => `scale(${props.scale})`};
  position: absolute;
`

interface AnimalIconButtonProps {
  name: IHand['animal']
  selected?: boolean
  onClick?: (e: React.SyntheticEvent) => void
}

export const AnimalIconButton = ({
  selected = false,
  name,
  onClick,
}: AnimalIconButtonProps) => {
  return (
    <ButtonOuter
      width={['60px', '60px', '60px', '70px']}
      height={['60px', '60px', '60px', '70px']}
    >
      <ButtonStyled
        selected={selected}
        onClick={onClick}
        width={['45px', '45px', '45px', '55px']}
        height={['45px', '45px', '45px', '55px']}
      >
        <AnimalPickerIcon
          singleLayer
          name={name}
          height='100%'
          color='white'
          {...ANIMAL_ICON_POSITIONS[name]}
        />
      </ButtonStyled>
    </ButtonOuter>
  )
}
